let variantSize
let variantProductId
let currentVariant = null
let variantColor
$(document).ready(function(){
    var url = new URL(window.location.href);
    var variantId = url.searchParams.get('variant');
    if (variantId !== null) {
        var variantsInfo = JSON.parse(document.getElementById('variants_data').textContent);
        for(const variant of variantsInfo){
          console.log(variant.id);
          console.log(variantId);
            if(variant.id == variantId){
                variantProductId = variant.product
                variantSize = variant.options[0]
                variantColor = variant.color
                const productId = variant.product
                mp_show_images(productId)
                mp_update_sizes()
                mp_select_variant()
                document.querySelectorAll('.labellll').forEach(function(label) {
                    if (label.getAttribute('secondproduct') == variantProductId) {
                        label.classList.add('round-border');
                    }
                });
                
                // Loop through all elements with the class '.pills-variant-labels' and modify classes and text based on conditions
                document.querySelectorAll('.pills-variant-labels').forEach(function(label) {
                    const labelValue = label.getAttribute('val').toUpperCase();
                    if (labelValue == variantSize && !label.classList.contains('disabled')) {
                        label.classList.add('round-border');
                    }
                    if (labelValue == variantSize && label.classList.contains('disabled')) {
                        document.querySelector('.product-form__submit').setAttribute('disabled', 'disabled');
                        document.querySelector('.add_to_cart_quantity').textContent = 'Agotado';
                    }
                });
            }
        }
    }
   document.querySelectorAll('.input-variant').forEach(function(input) {
    input.addEventListener('click', function() {
        const name = input.getAttribute('name').toUpperCase();
        // Check the 'name' attribute to determine the action
        if (name != 'COLOR') {
            variantSize = input.getAttribute('val');
            // Remove 'round-border' class from all '.pills-variant-labels'
            document.querySelectorAll('.pills-variant-labels').forEach(label => label.classList.remove('round-border'));
        }
        if (name == 'COLOR') {
            variantProductId = input.getAttribute('secondproduct');
            const productId = input.getAttribute('secondproduct');
            // Assuming mp_show_images is a function defined elsewhere in your JavaScript
            mp_show_images(productId);
            // Remove 'round-border' class from all '.labellll'
            document.querySelectorAll('.labellll').forEach(label => label.classList.remove('round-border'));
          document.querySelector('.js-media-sublist').swiper.slideTo(0)
        }
        // Assuming mp_update_sizes and mp_select_variant are functions defined elsewhere in your JavaScript
        mp_update_sizes();
        input.classList.add('round-border');
        mp_select_variant();
    });
  });
})

function mp_show_images(productId){
    Array.prototype.forEach.call(document.querySelectorAll(".js-media-sublist [data-element]:not([data-element='" + productId + "'])"), (e) => {
        e.classList.add("non-swiper-slide"), e.classList.remove("swiper-slide"), e.removeAttribute("style");
    }),
    Array.prototype.forEach.call(document.querySelectorAll(".js-media-sublist [data-element='" + productId + "']"), (e) => {
        e.classList.remove("non-swiper-slide"), e.classList.add("swiper-slide"), e.removeAttribute("style");
    }),
    Array.prototype.forEach.call(document.querySelectorAll(".js-media-list [data-element]:not([data-element='" + productId + "'])"), (e) => {
        e.classList.add("non-swiper-slide"), e.classList.remove("swiper-slide"), e.removeAttribute("style");
    }),
    Array.prototype.forEach.call(document.querySelectorAll(".js-media-list [data-element='" + productId + "']"), (e) => {
        e.classList.remove("non-swiper-slide"), e.classList.add("swiper-slide"), e.removeAttribute("style");
    });
}
function mp_select_variant(){
    var variantsInfo = JSON.parse(document.getElementById('variants_data').textContent);
    for(const variant of variantsInfo){
        if(variant.options.includes(variantSize) && variant.product == variantProductId && variant.available){
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.href);
            currentVariant = variant.id
            variantColor = variant.color
            document.querySelectorAll('.product__sku').forEach(function(skuElement) {
                skuElement.innerHTML = '<span class="visually-hidden">SKU:</span>' + variant.sku + '</p>';
            });
            
            var price = variant.price;
            
            // Handling product pricing and sale display
            if (variant.compare_at_price) {
                document.querySelectorAll('.price-item.price-item--regular').forEach(function(item) {
                    item.textContent = variant.compare_at_price;
                });
                document.querySelectorAll('.price-item.price-item--sale').forEach(function(item) {
                    item.textContent = variant.price;
                });
                document.querySelectorAll('.price__sale').forEach(function(sale) {
                    sale.style.display = 'flex';
                });
                document.querySelectorAll('.price__regular').forEach(function(regular) {
                    regular.style.display = 'none';
                });
                document.querySelectorAll('.product .price').forEach(function(price) {
                    price.classList.add('price--on-sale');
                });
                const discountPercentage = (100 - parseInt(parseFloat(variant.price.replace('$ ', '').replace(',', '')) * 100 / parseFloat(variant.compare_at_price.replace('$ ', '').replace(',', ''))));
                document.querySelectorAll('.badge--bottom-left').forEach(function(badge) {
                    badge.textContent = 'Sale -' + discountPercentage + ' %';
                });
            } else {
                document.querySelectorAll('.price-item.price-item--regular').forEach(function(item) {
                    item.textContent = price;
                });
                document.querySelectorAll('.product .price').forEach(function(price) {
                    price.classList.remove('price--on-sale');
                });
                document.querySelectorAll('.price__sale').forEach(function(sale) {
                    sale.style.display = 'none';
                });
                document.querySelectorAll('.price__regular').forEach(function(regular) {
                    regular.style.display = 'flex';
                });
            }
        }
    }
}
function mp_update_sizes(){
    var variantsInfo = JSON.parse(document.getElementById('variants_data').textContent);
    let sizes = []
    for(const variant of variantsInfo){
        if(variant.product == variantProductId){
            if(variant.available){
                sizes.push(variant.options[0])
            }
        }
    }
    //console.log('tamaños disponibles')
    //console.log(sizes)
    let available = true
    const inputs = document.querySelectorAll('#SingleOptionSelector-0 input');

    // Iterate over each input
    inputs.forEach(function(input) {
        // Check if the input's value is included in the 'sizes' array
        if (sizes.includes(input.value)) {
            // If it is included, remove the 'disabled' class
            input.classList.remove('disabled');
        } else {
            // If it is not included, add the 'disabled' class
            input.classList.add('disabled');
            // Additionally, check if the variantSize matches this input's value
            if (variantSize == input.getAttribute('val')) {
                available = false; // Set 'available' to false if the variant size matches and is disabled
            }
        }
    });
    //console.log(available)
    if (!available) {
        // Log the elements to console for debugging purposes
        //console.log(document.querySelectorAll('.labellll *[val="' + variantSize + '"]'));
    
        // Remove 'round-border' class from all elements with a matching 'val' attribute in the 'pills-variant-labels' class
        document.querySelectorAll('*[val="' + variantSize + '"].pills-variant-labels').forEach(element => {
            element.classList.remove('round-border');
        });
    
        // Disable the submit button and change its text to 'SOLD OUT'
        const submitButton = document.querySelector('.product-form__submit');
        if (submitButton) {
            submitButton.setAttribute('disabled', 'disabled');
            submitButton.textContent = 'SOLD OUT';
        }
    
        // Reset the current variant tracking variable
        currentVariant = null;
    } else {
        // Add 'round-border' class to all elements with a matching 'val' attribute in the 'pills-variant-labels' class
        document.querySelectorAll('*[val="' + variantSize + '"].pills-variant-labels').forEach(element => {
            element.classList.add('round-border');
        });
    
        // Enable the submit button and change its text to 'ADD TO CART'
        const submitButton = document.querySelector('.product-form__submit');
        if (submitButton) {
            submitButton.removeAttribute('disabled');
            submitButton.textContent = 'ADD TO CART';
        }
    }
}

function mp_add_to_cart(){
    const color = variantColor
    const size = variantSize
    const product = currentVariant

    let config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const cart = document.querySelector("cart-drawer")
    const formData = new FormData();
    formData.append('Talla', size);
    formData.append('COLOR', color);
    formData.append('form_type', 'product'); 
    formData.append('id', product);
    //formData.append('properties', JSON.stringify({"color":color}));
    formData.append('quantity', $('.quantity__input').val());
    if (cart) {
        formData.append(
            "sections",
            cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        cart.setActiveElement(document.activeElement);
    }
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
        //console.log(this)
        if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage) return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.querySelector("span").classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
        } else if (!cart) {
            window.location = window.routes.cart_url;
            return;
        }

        if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
            });
        this.error = false;
        const quickAddModal = document.querySelector("quick-add-modal");
        if (quickAddModal) {
            document.body.addEventListener(
                "modalClosed",
                () => {
                    setTimeout(() => {
                        cart.renderContents(response);
                    });
                },
                { once: true }
            );
            quickAddModal.hide(true);
        } else {
            cart.renderContents(response);
        }
    })
    .catch((e) => {
        console.error(e);
    })
}